module.exports = __webpack_public_path__ + "static/media/matt-moran.67cbe6f3.png";